__turbopack_context__.v({
  "className": "archivo_15c70a64-module__AcBMoW__className",
});
